export default __webpack_public_path__ + "static/media/artifact-registry.9aec8af5.svg";